import {Injectable} from '@angular/core';

import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {KngModalComponent} from "@layout/kingswell/kng-modal/kng-modal.component";

@Injectable()
export class KngModalService {
  constructor(private modalService: NgbModal) {
  }

  launch(messageOptions): NgbModalRef {
    let modalInstance = this.modalService.open(KngModalComponent, {
      backdrop: 'static',
      size: 'lg',
      keyboard: false,
      windowClass: 'kng-modal-md'
    });

    modalInstance.componentInstance.type = messageOptions.type;
    modalInstance.componentInstance.title = messageOptions.title;
    modalInstance.componentInstance.contents = messageOptions.contents;
    modalInstance.componentInstance.button = messageOptions.button;

    return modalInstance;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/services/kngModal.service.ts